export default __webpack_public_path__ + "static/serc-384cc70ebfc44631cc514d87bd8a0d53.png";